import { render, staticRenderFns } from "./DeleteTvSpotDialog.vue?vue&type=template&id=b3d0361c&"
import script from "./DeleteTvSpotDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteTvSpotDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports